import { storeToRefs } from "pinia";
import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import LxcError from "~/core/models/LxcError.class";
import licenseService from "~/modules/license/services/license.service";
import { UserSessionEntityType } from "~/modules/user/models/UserSessionEntityType.enum";
import { useUserSession } from "~/modules/user/stores/useUserSession";

export function useUploadLicense(organizationCode?: number) {
  const error: Ref<LxcError | undefined> = ref();
  const isLoading = ref(false);

  const { can } = useAcl();

  async function uploadLicense(
    licenseFile: File,
    progress: Ref<number | undefined | null>,
  ) {
    isLoading.value = true;
    error.value = undefined;

    const response = await licenseService.uploadLicenseFile(
      licenseFile,
      progress,
      organizationCode,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }
    isLoading.value = false;
  }

  /**
   * Return true if the current user has the permssions to update a license, false otherwise
   * @returns
   */
  function canUploadLicense() {
    const { userSession } = storeToRefs(useUserSession());

    return (
      (userSession.value?.entity.type === UserSessionEntityType.OPERATOR &&
        can(ACLRoles.CAN_WRITE_LICENSE)) ||
      (userSession.value?.entity.type === UserSessionEntityType.BUSINESS_UNIT &&
        can(ACLRoles.CAN_WRITE_FEATURE))
    );
  }

  return {
    isLoading,
    error,
    uploadLicense,
    canUploadLicense,
  };
}
